export const notificationsQuery = `
  query MyQuery($siteId:[QueryArgument]) {
    globalSet(siteId: $siteId, id: "6") {
      ... on notifications_GlobalSet {
        notifications {
          ... on notificationsBlock_Entry {
            key: dateUpdated
            notification
            startDate @formatDateTime (format: "Ymd")
            endDate @formatDateTime (format: "Ymd")
          }
        }
      }
    }
  }
`
